/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SearchPageContainer_user$ref: FragmentReference;
export type SearchPageContainer_user = {|
  +id: string,
  +$refType: SearchPageContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "SearchPageContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '112aa941f43fb99044f849263d733265';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Search/__generated__/SearchPageContainer_user.graphql.js